import { createActions } from 'redux-actions';

export const {
  watchRequest,
  watchRequestSuccess,
  watchRequestFailure,
  unwatchRequest,
  unwatchRequestSuccess,
  unwatchRequestFailure,
  // VIEW_LOG ACTIVITY
  // setViewLogRequest,
  // setViewLogRequestSuccess,
  //setViewLogRequestFailure,
  // SHOW FILTER RESULTS
  showFilterResults,
  // GET REQUESTS BY PROFILE
  getRequestsByProfile,
  getRequestsByProfileSuccess,
  getRequestsByProfileError,
  //GET ALL REQUESTS
  getAllRequests,
  getAllRequestsSuccess,
  getAllRequestsError,

  //GET FILTER REQUESTS
  getFilterRequests,
  getFilterRequestsSuccess,
  getFilterRequestsError,

  // FILTER REQUESTS
  filterRequests,
  filterRequestsSuccess,
  filterRequestsError,
  //GET REQUEST
  getRequest,
  getRequestSuccess,
  getRequestError,
  //POST REQUEST
  createRequest,
  createRequestSuccess,
  createRequestError,
  //PUT REQUEST
  updateRequest,
  updateRequestSuccess,
  updateRequestError,
  //DELETE REQUEST
  deleteRequest,
  deleteRequestSuccess,
  deleteRequestError,
  //SEARCH REQUEST
  searchRequests,
  searchRequestsSuccess,
  searchRequestsError,
  // GET ACTUAL CLIENTS (collaborated with)
  getActualClients,
  getActualClientsSuccess,
  getActualClientsError,
  // CHECK_VEHICLES_AND_DRIVERS
  checkCompanyVehiclesAndDrivers,
} = createActions(
  'WATCH_REQUEST',
  'WATCH_REQUEST_SUCCESS',
  'WATCH_REQUEST_FAILURE',
  'UNWATCH_REQUEST',
  'UNWATCH_REQUEST_SUCCESS',
  'UNWATCH_REQUEST_FAILURE',
  // VIEW_LOG ACTIVITY
  // 'SET_VIEW_LOG_REQUEST',
  // 'SET_VIEW_LOG_REQUEST_SUCCESS',
  // 'SET_VIEW_LOG_REQUEST_FAILURE',
  'SHOW_FILTER_RESULTS',
  'GET_REQUESTS_BY_PROFILE',
  'GET_REQUESTS_BY_PROFILE_SUCCESS',
  'GET_REQUESTS_BY_PROFILE_ERROR',
  'GET_ALL_REQUESTS',
  'GET_ALL_REQUESTS_SUCCESS',
  'GET_ALL_REQUESTS_ERROR',

  'GET_FILTER_REQUESTS',
  'GET_FILTER_REQUESTS_SUCCESS',
  'GET_FILTER_REQUESTS_ERROR',

  'FILTER_REQUESTS',
  'FILTER_REQUESTS_SUCCESS',
  'FILTER_REQUESTS_ERROR',
  'GET_REQUEST',
  'GET_REQUEST_SUCCESS',
  'GET_REQUEST_ERROR',
  'CREATE_REQUEST',
  'CREATE_REQUEST_SUCCESS',
  'CREATE_REQUEST_ERROR',
  'UPDATE_REQUEST',
  'UPDATE_REQUEST_SUCCESS',
  'UPDATE_REQUEST_ERROR',
  'DELETE_REQUEST',
  'DELETE_REQUEST_SUCCESS',
  'DELETE_REQUEST_ERROR',
  'SEARCH_REQUESTS',
  'SEARCH_REQUESTS_SUCCESS',
  'SEARCH_REQUESTS_ERROR',
  'GET_ACTUAL_CLIENTS',
  'GET_ACTUAL_CLIENTS_SUCCESS',
  'GET_ACTUAL_CLIENTS_ERROR',
  'CHECK_COMPANY_VEHICLES_AND_DRIVERS'
);
